import { emsDarkGrey, emsDarkGreyHover, emsMediumGrey } from "@electricMotorShop/EmsVariables";
import { autocompleteBrandsStyles } from "@insite/content-library/Widgets/Header/AutocompleteBrands";
import { autocompleteProductsStyles } from "@insite/content-library/Widgets/Header/AutocompleteProducts";
import { headerLinkListStyles } from "@insite/content-library/Widgets/Header/HeaderLinkList";
import { searchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory";
import { headerStyles } from "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationHeader";
import { css } from "styled-components";

// HeaderLinkList
headerLinkListStyles.headerLinkListWrapper = {
    css: css`
        align-items: center;
        margin: 0 10px;
    `,
};

headerLinkListStyles.link = {
    typographyProps: {
        variant: "headerTertiary",
        css: css`
            margin: 0 9px 0 9px;
            display: inline-block;
        `,
    },
};

// AutocompleteProducts
autocompleteProductsStyles.titleLink = {
    typographyProps: {
        ellipsis: true,
        css: css`
            width: 100%;
            text-align: left;
            margin: 0;
        `,
    },
    css: css`
        width: 100%;
    `,
};

autocompleteProductsStyles.erpNumberText = {
    ellipsis: true,
    css: css`
        width: 100%;
        text-align: left;
        margin: 5px 0 0 0;
    `,
};

autocompleteProductsStyles.headerText = {
    weight: "bold",
    css: css`
        text-align: left;
        margin: 10px 0 5px 0;
        border-bottom: 1px solid ${emsMediumGrey};
    `,
};

autocompleteProductsStyles.imageGridItem = {
    width: 3,
    css: css`
        max-width: 55px;
        max-height: 50px;
        flex-basis: 55px;
    `,
};

// AutocompleteCategories
// In it's own override

// AutocompleteBrands
autocompleteBrandsStyles.headerText = {
    weight: "bold",
    css: css`
        text-align: left;
        margin: 10px 0 5px 0;
        border-bottom: 1px solid ${emsMediumGrey};
    `,
};

// SeachHistory
searchHistoryStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 0 20px 15px 20px;
    `,
};

// OnePageCheckoutConfirmationHeader
headerStyles.printButton = {
    css: css`
    background: ${emsDarkGrey};
    border-color: ${emsDarkGrey};
    &:hover:not(:disabled),
    &:focus:not(:disabled) {
        background-color: ${emsDarkGreyHover};
        border-color: ${emsDarkGreyHover};
    `,
};
